namespace AgerLMS.LMS {
    export interface OrderItemRow {
        Id?: number;
        OrderId?: number;
        UserId?: number;
        OrderItemEntityType?: EntityTypes;
        EntityId?: number;
        ItemName?: string;
        AmountPaid?: number;
        ItemPrice?: number;
        Discount?: number;
        Tax?: number;
        DeliveryFee?: number;
        UsagePeriod?: number;
        Quantity?: number;
        OrderOrderGuid?: string;
        OrderOrderState?: number;
        OrderConfirmDate?: string;
        OrderConfirmUserId?: number;
        OrderInsertDate?: string;
        OrderInsertUserId?: number;
        UserDisplayName?: string;
        ItemThumbnail?: string;
        ItemCoverImage?: string;
        CourseId?: number;
        CourseThumbnail?: string;
        CourseCoverImage?: string;
        BundleId?: number;
        BundleThumbnail?: string;
        BundleCoverImage?: string;
        ProductId?: number;
        ProductThumbnail?: string;
        ProductCoverImage?: string;
        InsertUserId?: number;
        InsertDate?: string;
        InsertUserDisplayName?: string;
    }

    export namespace OrderItemRow {
        export const idProperty = 'Id';
        export const nameProperty = 'ItemName';
        export const localTextPrefix = 'LMS.OrderItem';
        export const deletePermission = '?';
        export const insertPermission = '?';
        export const readPermission = 'LMS:OrderItem:Read';
        export const updatePermission = '?';

        export declare const enum Fields {
            Id = "Id",
            OrderId = "OrderId",
            UserId = "UserId",
            OrderItemEntityType = "OrderItemEntityType",
            EntityId = "EntityId",
            ItemName = "ItemName",
            AmountPaid = "AmountPaid",
            ItemPrice = "ItemPrice",
            Discount = "Discount",
            Tax = "Tax",
            DeliveryFee = "DeliveryFee",
            UsagePeriod = "UsagePeriod",
            Quantity = "Quantity",
            OrderOrderGuid = "OrderOrderGuid",
            OrderOrderState = "OrderOrderState",
            OrderConfirmDate = "OrderConfirmDate",
            OrderConfirmUserId = "OrderConfirmUserId",
            OrderInsertDate = "OrderInsertDate",
            OrderInsertUserId = "OrderInsertUserId",
            UserDisplayName = "UserDisplayName",
            ItemThumbnail = "ItemThumbnail",
            ItemCoverImage = "ItemCoverImage",
            CourseId = "CourseId",
            CourseThumbnail = "CourseThumbnail",
            CourseCoverImage = "CourseCoverImage",
            BundleId = "BundleId",
            BundleThumbnail = "BundleThumbnail",
            BundleCoverImage = "BundleCoverImage",
            ProductId = "ProductId",
            ProductThumbnail = "ProductThumbnail",
            ProductCoverImage = "ProductCoverImage",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            InsertUserDisplayName = "InsertUserDisplayName"
        }
    }
}
